<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_3">Contents</a></h1><a id="page_3">
</a><p class="toc-fm"><a id="page_3"></a><a href="#/005_Preface#fm-1">Preface</a></p>
<p class="toc-chap"><a href="#/006_Chapter01#ch-1">1 <span class="pad">Thirty Years That Changed the World</span></a></p>
<p class="toc-chap"><a href="#/007_Chapter02#ch-2">2 <span class="pad">Bridges and Ditches in First Century Society</span></a></p>
<p class="toc-chap"><a href="#/008_Chapter03#ch-3">3 <span class="pad">Luke and His Friends</span></a></p>
<p class="toc-chap"><span href="#/009_Chapter04#ch-4" title="Link target outside of Sample">4 <span class="pad">What of Their Approach?</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter05#ch-5" title="Link target outside of Sample">5 <span class="pad">What of Their Lifestyle?</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter06#ch-6" title="Link target outside of Sample">6 <span class="pad">What of Their Message?</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter07#ch-7" title="Link target outside of Sample">7 <span class="pad">What of Their Apologetics?</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter08#ch-8" title="Link target outside of Sample">8 <span class="pad">What of Their Methods?</span></span></p>
<p class="toc-chap"><span href="#/014_Chapter09#ch-9" title="Link target outside of Sample">9 <span class="pad">What of Their Church Planting?</span></span></p>
<p class="toc-chap1"><span href="#/015_Chapter10#ch-10" title="Link target outside of Sample">10 <span class="pad1">What of Their Pastoral Care?</span></span></p>
<p class="toc-chap1"><span href="#/016_Chapter11#ch-11" title="Link target outside of Sample">11 <span class="pad1">What of Their Church Life?</span></span></p>
<p class="toc-chap1"><span href="#/017_Chapter12#ch-12" title="Link target outside of Sample">12 <span class="pad1">What of Their Leadership?</span></span></p>
<p class="toc-chap1"><span href="#/018_Chapter13#ch-13" title="Link target outside of Sample">13 <span class="pad1">What of Their Hardships?</span></span></p>
<p class="toc-chap1"><span href="#/019_Chapter14#ch-14" title="Link target outside of Sample">14 <span class="pad1">What of the Holy Spirit?</span></span></p>
<p class="toc-chap1"><span href="#/020_Chapter15#ch-15" title="Link target outside of Sample">15 <span class="pad1">What of Their Priorities?</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Contents.vue?633b3986